const FromArr = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	multiple: true,
	collapseTags: true,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "日期：",
	StartTime: '',
	EndTime: '',
	inputtype: "dateSection",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "date",
	placeholder: "选择日期",
	heightLeft: 32,
	heightRight: 32,
	widthLeft: 150,
	widthRight: 150,
	disabled: false,
	marginLeft: 80,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500
}]

const FromArr2 = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "产品分类（L3）：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择产品分类",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}]



export {
	FromArr,
	FromArr2
}